import { getDirectionsFaqs } from "@/utils/getDirectionsFaqs";

interface DirectionsFAQProps {
  companyName: string;
  address: string;
  telephone: string;
  parkcnt: number;
  hasParkinglot: boolean;
  sigunguName: string;
}

export const DirectionsFAQ = (props: DirectionsFAQProps) => {
  const faqs = getDirectionsFaqs(props);
  const { companyName } = props;

  return (
    <section className="dr-section" aria-labelledby="dr-faq-title">
      <h2 id="dr-faq-title" className="dr-section__title">
        {`${companyName} 찾아가시는 길 자주 묻는 질문`}
      </h2>
      <dl className="dr-faq">
        {faqs.map((faq, idx) => (
          <div key={idx} className="dr-faq__item">
            <dt className="dr-faq__q">{`Q. ${faq.q}`}</dt>
            <dd className="dr-faq__a">{faq.a}</dd>
          </div>
        ))}
      </dl>
    </section>
  );
};
